import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

export abstract class MarpolModelBase extends BaseModel
{
    abstract getMarpolZones(): Promise<ZoneFeature[] | null>;
}

let MarpolModel: MarpolModelBase|null = null;

function setMarpolModel(model: MarpolModelBase)
{
    MarpolModel = model;
}

export { MarpolModel, setMarpolModel };
